import { useApi } from '@/api';
import { Page, PageSkeleton } from '@/components';
import {
  DropdownFilter,
  Flex,
  TextSearchFilter,
  useTableProps,
  EmptyBox
} from '@blockanalitica/ui';
import WalletsTable from '../wallets/WalletsTable';
import BadDebtKpis from './BadDebtKpis';
import HistoricTabs from './HistoricTabs';
import { DEFAULT_NETWORK } from '@/constants';

type WalletsAssetsData = Array<{ value: string; label: string }>;

type WalletsAssetsResponse = {
  supplied_assets: WalletsAssetsData;
  borrowed_assets: WalletsAssetsData;
};

export default function UnderwaterWalletsPage() {
  const network = DEFAULT_NETWORK;

  const { pagination, filters } = useTableProps({
    filtersDebounceTime: 500,
    initialFilters: {
      textSearch: '',
      selectedSupplyOption: '',
      selectedBorrowOption: ''
    }
  });

  const [data, error] = useApi<WalletsAssetsResponse>({
    url: '/wallets/assets/'
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page title="Underwater Wallets">
        <BadDebtKpis />
        <HistoricTabs />
        <Flex
          flexDirection={['column', 'row']}
          gap={['xs', 's']}
          justifyContent={['center', 'flex-end']}
          alignItems="center">
          <Flex flexDirection="row" gap={['xs', 's']}>
            <DropdownFilter
              multi={true}
              withCryptoIcon={true}
              filterField="selectedSupplyOption"
              options={data.supplied_assets}
              cryptoIconProps={{ network }}
              pagination={pagination}
              titleFormat={(filteredCount: number) =>
                `Supplied assets (${filteredCount})`
              }
              {...filters}
            />
            <DropdownFilter
              multi={true}
              withCryptoIcon={true}
              filterField="selectedBorrowOption"
              options={data.borrowed_assets}
              cryptoIconProps={{ network }}
              pagination={pagination}
              titleFormat={(filteredCount: number) =>
                `Borrowed assets (${filteredCount})`
              }
              {...filters}
            />
          </Flex>
          <Flex flexDirection="row">
            <TextSearchFilter
              pagination={pagination}
              placeholder="Search by wallet"
              {...filters}
            />
          </Flex>
        </Flex>
        <WalletsTable
          url="/wallets/bad-debt-wallets/"
          tableFilters={{
            supplyAssetsFiltered:
              filters.filtersApplied['selectedSupplyOption'],
            borrowAssetsFiltered: filters.filtersApplied['selectedBorrowOption']
          }}
          textSearch={filters.filtersApplied['textSearch']}
          pagination={pagination}
          emptyComponent=<EmptyBox message="No wallets are currently underwater" />
        />
      </Page>
    );
  }

  return <PageSkeleton />;
}
